import React, {Component} from 'react'
import CalculatorFormulaForm from "./formula.component.jsx"


class CalculatorFormulasForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            list: this.props.value || [],
            terms: this.props.terms || [],
        }
        this.deleteItem = this.deleteItem.bind(this)
        this.changeItem = this.changeItem.bind(this)
    }

    componentDidMount() {
        this.setState({
            list: this.props.value || [],
            terms: this.props.terms || [],
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            list: nextProps.value || [],
            terms: nextProps.terms || [],
        })
    }

    deleteItem(index) {
        this.setState({
            list: this.state.list.filter((_, i) => i !== index)
        }, () => {
            this.onChange()
        })
    }

    changeItem(index, value) {
        const list = this.state.list
        list[index] = value
        this.setState({
            list: list
        }, () => {
            this.onChange()
        })
    }

    onChange() {
        const onChange = this.props.onChange || function () {}
        onChange(this.state.list)
    }

    render() {

        return (
            <div>
                {this.state.list.map((value, index) => {
                    return <CalculatorFormulaForm
                        key={'calculator-formula-' + index}
                        value={value}
                        index={index}
                        terms={this.state.terms}
                        onDelete={this.deleteItem}
                        onChange={this.changeItem}
                    />
                })}
            </div>

        );
    }
}

export default CalculatorFormulasForm


// WEBPACK FOOTER //
// ./src/product/form/calculator/formulas.component.jsx